// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"83e17ff2","488":"098d5dd4"}[chunkId] + ".chunk.js";
};